import { get } from 'lodash'
import { connect } from 'react-redux'
import useRealtimeV2 from '@edulastic/common/src/customHooks/useRealtimeV2'
import {
  removeItemBankPermissionAction,
  addItemBankPermissionAction,
} from './student/Login/ducks'
import { getRealtimeDistrictId } from './author/src/selectors/user'

const RealTimeCollectionWatch = ({
  userData,
  addItemBankPermission,
  removeItemBankPermission,
}) => {
  const { userId, realtimeDistrictId } = userData
  const topics = [
    `districtId:${realtimeDistrictId}:collection:permission:districtId:${realtimeDistrictId}`,
  ]
  useRealtimeV2(topics, {
    // For user level permissions orgId will be userId
    addPermission: (payload) => {
      if (payload.orgId === userId) {
        addItemBankPermission(payload)
      }
    },
    deletePermission: (payload) => {
      if (payload.orgId === userId) {
        removeItemBankPermission(payload)
      }
    },
  })
  return null
}

export default connect(
  (state) => {
    const { user } = state
    return {
      userData: {
        userId: get(user, 'user._id', ''),
        districtIds: get(user, 'user.districtIds', []),
        realtimeDistrictId: getRealtimeDistrictId(state),
      },
    }
  },
  {
    addItemBankPermission: addItemBankPermissionAction,
    removeItemBankPermission: removeItemBankPermissionAction,
  }
)(RealTimeCollectionWatch)
